enum DataFromBackend {
    EMPTY_PARAGRAPH = '<p><br></p>',
}

export default DataFromBackend
